export default {"src":"/_next/static/media/user.641af22a.svg","height":20,"width":20};